const defaultCenter = { lat: 25.7914933, lng: -80.1389693 };

const circleOptions = {
  strokeOpacity: 0.8,
  strokeWeight: 2,
  fillOpacity: 0.18,
  strokeColor: '#146ef5',
  fillColor: '#146ef5',
  clickable: false,
  draggable: false,
  editable: false,
  visible: true
};

const polygonOptions = {
  strokeOpacity: 0.9,
  strokeWeight: 2,
  fillOpacity: 0.2,
  strokeColor: '#146ef5',
  fillColor: '#146ef5'
};

const normalizeCenter = center => {
  if (!center) return null;

  const lat = Number(center.lat);
  const lng = Number(center.lng);
  return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
};

const getZoom = center => {
  return normalizeCenter(center) ? 14 : 5;
};

const getPosition = center => {
  return normalizeCenter(center) || defaultCenter;
};

const getCenter = center => {
  return normalizeCenter(center) || defaultCenter;
};

const getMapDefinition = center => ({
  circleOptions,
  polygonOptions,
  defaultCenter,
  center: getCenter(center),
  position: getPosition(center),
  zoom: getZoom(center)
});

export default getMapDefinition;
